// src/app/store/auth/auth.effects.ts
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  logout,
  logoutSuccess,
  logoutFailure,
  clearAuth,
  redirect,
} from './auth.actions';
import { switchMap, tap, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';
import { selectAccessToken } from './auth.selectors';
// import { AuthApi } from '../../services/auth.api'; // si tienes API para revoke

export class AuthEffects {
  private actions$ = inject(Actions);
  private router = inject(Router);
  private store = inject(Store);
  // private api = inject(AuthApi);

  // Si tienes endpoint para revocar refreshToken, úsalo:
  // Detecta el uso de la accion logout al llamar un dispatch
  logout$ = createEffect(() =>
    this.actions$.pipe(
      ofType(logout),
      withLatestFrom(this.store.select(selectAccessToken)),
      switchMap(([_, t]) => {
        // return this.api.revoke(t?.refreshToken ?? '').pipe(
        //   map(() => logoutSuccess()),
        //   catchError(err => of(logoutFailure({ error: err })))
        // );
        return of(logoutSuccess()); // sin API de revoke, llama al action de logout succes
      })
    )
  );

  // Al completar el logout => limpiar estado y navegar a /login
  logoutSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(logoutSuccess), // detecta el llamado al logout success
        tap(() => {
          this.store.dispatch(clearAuth()); // llama a la accion de clearAuth en reducer Auth
          this.router.navigateByUrl('/login');
        })
      ),
    { dispatch: false }
  );

  // Si falla revoke igual limpia y navega (mejor dejar al usuario fuera)
  logoutFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(logoutFailure),
        tap(() => {
          this.store.dispatch(clearAuth());
          this.router.navigateByUrl('/login');
        })
      ),
    { dispatch: false }
  );

  redirect$ = createEffect(
  () =>
    this.actions$.pipe(
      ofType(redirect),
      withLatestFrom(this.store.select(selectAccessToken)),
      tap(([_, token]) => {
        if (token) {
          const access = token?.accessToken ?? '';
          const refresh = token?.refreshToken ?? '';

          if (!access && !refresh) return;

          // arma el fragment con URLSearchParams (escapa automático)
          const params = new URLSearchParams();
          if (access)  params.set('access_token', access);
          if (refresh) params.set('refresh_token', refresh);

          const url = `https://jwt.ms/#${params.toString()}`;
          // misma pestaña:
          window.location.assign(url);
        }
      })
    ),
  { dispatch: false }
);
}
